export default __webpack_public_path__ + "static/3-new-order-1f1a8505a04657ed43435c066c332f54.png";